export const environment = {
    serverUrl: 'https://testapivinculacionesfincomercio.bsccolombia.com',
    serverActualizacionUrl: 'https://testactualizacionesfincomercio.bsccolombia.com',
    wsUrl: 'https://testapivinculacionesfincomercio.bsccolombia.com:9552',
    colorOne: '#7C3AED',
    colorTwo: '#8B5CF6',
};
